import React, { useCallback, useEffect } from "react";
import PublicWrapper from "app/components/PublicWrapper";
import StudentPrograms from "../ManagePrograms/ManageStudentPrograms";
import { RootState } from "typedefs";
import { useDispatch, useSelector } from "react-redux";
import SiteWrapper from "app/components/Layouts/SiteWrapper";
import { UserState } from "app/reducers/user";
import { Loading } from "app/components/Wrappers";
import useUrlSeach from "app/utils/hooks/useUrlSearch";
import { schedulingFetchGet } from "app/utils/request/scheduling/fetch";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import useBookSessionData from "../Sessions/hooks/useBookSessionData";
import { setBookSession, setIsComplete } from "app/actions/scheduling/bookSession";
import { defaultSelection } from "../Sessions/helpers";


const PublicFacilityPrograms = () => {
  const userState = useSelector(
    (state: RootState): UserState => state.user
  );
  const bookLessonState = useSelector((state: RootState) => state.bookSession);
  const [searchParams, _] = useUrlSeach();
  const facilityId = searchParams.facilityId;
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fetcher = useCallback(() => {
    if (!facilityId) {
      return Promise.resolve([]);
    }
    const facilityPromise = schedulingFetchGet(
      `/facilities/${facilityId}`,
      {},
      {},
      null,
      true
    );
    const promise = Promise.all([facilityPromise])
      .then((response) => {
        return [response, response[0].coachProfiles];
      })
      .catch((_) => {
        history.push("/");
        toast.error(t("An unexpected error has occurred."));
      });
    return promise;
  }, [facilityId]);

  const [loadingBookLessonData, bookLessonData] = useBookSessionData(fetcher);

  useEffect(() => {
    if (loadingBookLessonData || facilityId === null) {
      return;
    }

    const coachCount = bookLessonData["facilities"][0]?.coachProfiles?.length;

    if (!loadingBookLessonData && bookLessonData["facilities"].length === 0) {
      history.push("/");
      toast.error(t("An unexpected error has occurred."));
      return;
    }

    if (bookLessonState.public && bookLessonState.isComplete) {
      dispatch(setIsComplete(false));
      return;
    }

    const initialData = defaultSelection(bookLessonData);

    let lessonState = {
      ...initialData,
      date: initialData.date.toISODate(),
      time: null,
      public: true,
    };

    if(coachCount > 1) {
      lessonState = {
        ...lessonState,
        coach: {
          fullName: t("All Coaches"),
          value: "all-coaches",
          id: "all-coaches",
        },
      };
    }

    dispatch(setBookSession(lessonState));
  }, [loadingBookLessonData, dispatch]);

  if (loadingBookLessonData || !bookLessonState.facility || userState.pending) {
    return <Loading />;
  }

  if (userState.data) {
    return (
      <SiteWrapper>
        <StudentPrograms isPublic />
      </SiteWrapper>
    );
  } else {
    return (
      <PublicWrapper>
        <StudentPrograms isPublic />
      </PublicWrapper>
    );
  }
};

export default PublicFacilityPrograms;
